import { render, staticRenderFns } from "./WidgetCardComponent.vue?vue&type=template&id=9b1f65aa&scoped=true&"
import script from "./WidgetCardComponent.vue?vue&type=script&lang=js&"
export * from "./WidgetCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./WidgetCardComponent.vue?vue&type=style&index=0&id=9b1f65aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1f65aa",
  null
  
)

export default component.exports